import React, { Component } from "react";
import _ from "lodash";

import PageArrowButton from "./PageArrowButton";

import "../../../../styles/components/utils/components/pageSelector/PageSelector.scss";

class PageSelector extends Component {
  renderPageBtns() {
    const navButtons = [];

    // first arrow button (first page)
    navButtons.push(
      <PageArrowButton
        key={Math.random()}
        direction="first"
        onClick={(e) => this.props.onPageSwitch(e, "first")}
        disabled={this.props.selected === 1 || this.props.disabled}
      />
    );

    // left arrow button (previous page)
    navButtons.push(
      <PageArrowButton
        key={Math.random()}
        direction="left"
        onClick={(e) => this.props.onPageSwitch(e, "left")}
        disabled={this.props.selected === 1 || this.props.disabled}
      />
    );

    // 5 page number buttons (2 previous pages, the page selected, 2 next pages)
    for (
      let i = Math.max(
        Math.min(this.props.selected - 3, this.props.totalPages - 5),
        0
      );
      i < Math.min(Math.max(this.props.selected + 2, 5), this.props.totalPages);
      i++
    ) {
      navButtons.push(
        <button
          key={i + 1}
          type="button"
          className="link page"
          onClick={(e) => this.props.onPageSwitch(e, i + 1)}
          disabled={i + 1 === this.props.selected || this.props.disabled}
        >
          {i + 1}
        </button>
      );
    }

    // right arrow button (next page)
    navButtons.push(
      <PageArrowButton
        key={Math.random()}
        direction="right"
        onClick={(e) => this.props.onPageSwitch(e, "right")}
        disabled={
          this.props.selected === this.props.totalPages || this.props.disabled
        }
      />
    );

    // last arrow button (last page)
    navButtons.push(
      <PageArrowButton
        key={Math.random()}
        direction="last"
        onClick={(e) => this.props.onPageSwitch(e, "last")}
        disabled={
          this.props.selected === this.props.totalPages || this.props.disabled
        }
      />
    );

    return navButtons;
  }

  render() {
    return <div id="pageSelector">{this.renderPageBtns()}</div>;
  }
}

export default PageSelector;
